import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — Escáner de Neuro-Inflamación',
    subtitle: '"Tu plan listo en minutos"',
    items: ['Test de autodiagnóstico en 5 minutos — sabés por dónde empezar', 'Los 7 síntomas que confundís con "la edad", identificados al toque', 'Mini-mapa SIBO–fatiga–niebla: cómo se conectan sin vueltas', 'Plan de acción para los primeros 3 días, ya armado'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — Protocolo Flash: 24h de Claridad',
    subtitle: '"Para leer hoy y aplicar mañana"',
    items: ['Menú de 24 horas listo — sin pensar, sin improvisar', 'Lista de compras argentina lista para usar en la verdulería', 'El principio del "Escudo Seco" en una sola página', 'Semáforo FODMAP argentino: verde, amarillo, rojo. Punto.'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — Manual del Interruptor Vagal',
    subtitle: '"3 ejercicios. 2 minutos. Resultado el mismo día."',
    items: ['3 ejercicios de 2 minutos para activar el nervio vago', 'La Respiración del Reset — la hacés sentada en el sillón', 'La Vibración Vagal — al despertar y antes de dormir', 'Activación Somática Cervical — al alcance en cualquier lado', 'Resultados notables desde la primera práctica'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — Guía de Supermercado Anti-Niebla',
    subtitle: '"Entrás al súper sabiendo qué llevar"',
    items: ['Guía rápida góndola por góndola: lista verde y lista roja', 'Marcas locales argentinas indicadas con nombre y apellido', 'Los 15 ingredientes ocultos que fermentan — los dejás en la estantería', 'Lectura de etiquetas en 30 segundos, sin lupa'],
    color: 'border-red-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — Hoja de Ruta: Nitidez 365',
    subtitle: '"El plan para que la nube no vuelva"',
    items: ['Sistema de mantenimiento en una sola hoja por mes', 'Calendario de 90 días listo — solo seguís la línea', 'Protocolo de Reintroducción simple, sin spreadsheets', 'La Regla del 80/20 para sostener el resultado en la vida real'],
    color: 'border-gray-500/30'
  }];
  const includes = ['Plan diario listo — arrancás hoy sin armar nada', 'Guías de lectura rápida (5–10 min) por capítulo', 'Tarjetas resumen para llevar en el celular', 'Semáforo FODMAP adaptado a Argentina', 'Tracker de síntomas en 3 minutos por día', 'Checklist imprimible por etapa', '100% adaptado a la mujer argentina +55'];
  return <section className="py-24 bg-brand-dark" data-id="element-229">
      <div className="container mx-auto px-4" data-id="element-230">
        <div className="max-w-5xl mx-auto" data-id="element-231">
          <div className="text-center mb-16" data-id="element-232">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-233">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-234">
                🏆 CÓDIGO NIEBLA CERO™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-235">
                5 Tomos + 5 Bonos — Guías de lectura rápida (5–10 min) diseñadas
                para implementación inmediata.
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-236">
            📚 5 TOMOS — RÁPIDOS DE LEER. FÁCILES DE APLICAR.
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-237">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-238">
                <div className="text-5xl shrink-0" data-id="element-239">{tomo.emoji}</div>
                <div data-id="element-240">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-241">
                    {tomo.title}
                  </h4>
                  <p className="text-sm text-brand-light italic mb-3" data-id="element-242">
                    {tomo.subtitle}
                  </p>
                  <ul className="space-y-2" data-id="element-243">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-244">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-245" />
                        <span data-id="element-246">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-247">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-248">
              Cada tomo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-249">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-250">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-251" />
                  <span className="text-gray-200" data-id="element-252">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}